//
//
//
//
//
//
//
//
//
var script = {
  name: 'VueWavify',
  inheritAttrs: false,
  props: {
    paused: {
      default: false,
      type: Boolean
    },
    points: {
      default: 3,
      type: Number
    },
    speed: {
      default: 0.15,
      type: Number
    },
    height: {
      default: 20,
      type: Number
    },
    amplitude: {
      default: 20,
      type: Number
    },
    fill: {
      default: 'blue',
      type: String
    },
    id: {
      default: null,
      type: String
    },
    style: {
      default: null,
      type: String
    }
  },

  data() {
    return {
      path: '',
      lastUpdate: 0,
      elapsed: 0,
      step: 0
    };
  },

  mounted() {
    if (!this.$frameId) {
      this.resume();
    }
  },

  beforeDestroy() {
    window.cancelAnimationFrame(this.$frameId);
    this.$frameId = 0;
  },

  methods: {
    containerWidth() {
      return this.$refs.wave.offsetWidth;
    },

    containerHeight() {
      return this.$refs.wave.offsetHeight;
    },

    calculateWavePoints() {
      const points = [];

      for (let i = 0; i <= Math.max(this.points, 1); i++) {
        const scale = 100;
        const x = i / this.points * this.containerWidth();
        const seed = (this.step + (i + i % this.points)) * this.speed * scale;
        const height = Math.sin(seed / scale) * this.amplitude;
        const y = Math.sin(seed / scale) * height + this.height;
        points.push({
          x,
          y
        });
      }

      return points;
    },

    buildPath(points) {
      let svg = `M ${points[0].x} ${points[0].y}`;
      const initial = {
        x: (points[1].x - points[0].x) / 2,
        y: points[1].y - points[0].y + points[0].y + (points[1].y - points[0].y)
      };

      const cubic = (a, b) => ` C ${a.x} ${a.y} ${a.x} ${a.y} ${b.x} ${b.y}`;

      svg += cubic(initial, points[1]);
      let point = initial;

      for (let i = 1; i < points.length - 1; i++) {
        point = {
          x: points[i].x - point.x + points[i].x,
          y: points[i].y - point.y + points[i].y
        };
        svg += cubic(point, points[i + 1]);
      }

      svg += ` L ${this.containerWidth()} ${this.containerHeight()}`;
      svg += ` L 0 ${this.containerHeight()} Z`;
      return svg;
    },

    redraw() {
      this.path = this.buildPath(this.calculateWavePoints());
    },

    draw() {
      if (!this.paused) {
        const now = new Date();
        this.elapsed += now - this.lastUpdate;
        this.lastUpdate = now;
        const scale = 1000;
        this.step = this.elapsed * Math.PI / scale;
        this.redraw();
      }
    },

    update() {
      this.draw();

      if (this.$frameId) {
        this.resume();
      }
    },

    resume() {
      this.$frameId = window.requestAnimationFrame(this.update);
      this.lastUpdate = new Date();
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', _vm._g({
    ref: "wave",
    staticClass: "vue-wavify-wave",
    style: _vm.style,
    attrs: {
      "id": _vm.id
    }
  }, _vm.$listeners), [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "100%",
      "height": "100%"
    }
  }, [_vm._t("default"), _vm._v(" "), _c('path', _vm._b({
    attrs: {
      "d": this.path,
      "fill": _vm.fill
    }
  }, 'path', _vm.$attrs, false))], 2)]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-7018f0ac_0", {
    source: ".vue-wavify-wave[data-v-7018f0ac]{display:inline-block;width:100%}.vue-wavify-wave svg[data-v-7018f0ac]{width:100%;height:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-7018f0ac";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installVueWavify(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('VueWavify', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
